
const vuetifyCustom = {
    init (self, instance) {
        self.$vuetify.theme.dark = instance.theme.dark;
        self.$vuetify.theme.themes.light.primary = instance.theme.theme_color;
        self.$vuetify.theme.themes.dark.primary = instance.theme.theme_color;
        this.AddStyle(`
            .home-bottom-top-border {
                border-top: 2px solid ${instance.theme.theme_color};
             }
             .home-bottom-top-border  .v-icon.v-icon{
                color:${instance.theme.theme_color};
             }             
             .title-category{
                color:${instance.theme.titles_txt_color};
             }
             .menu-categories .v-list-item .v-list-item__title{
                color:${instance.theme.theme_color};
             }
             .menu-category.tabs .v-card__title{
                color:${instance.theme.theme_color};
             }
             .menu-category.tabs .v-card.active{
                background-color: ${instance.theme.theme_color};
             }
             .menu-category.tabs .v-card.active .v-card__title{
                color: #FFFFFF;
             }
        `);
        if(instance.theme.suppliers_background_image !== undefined &&  instance.theme.suppliers_background_image !== null && instance.theme.suppliers_background_image.toString().length > 1){
            this.AddStyle(`
                .overlay-bck {
                    background-image: url("${instance.theme.suppliers_background_image}");
                 }
            `);

            this.AddStyle(`
                .background-app {
                    background-image: url("${instance.theme.suppliers_background_image}")!important;
                    background-size: cover!important;
                    background-position: center!important;
                 }
                 .background-app .v-main{
                    background-color: rgba(0,0,0,0.5)!important;
                 }
            `);
        }
        this.AddStyle(instance.style_custom);
        if(!instance.theme.dark) {
					this.AddStyle(`
						.v-application {
							background-color: ${instance.theme.page_bgcolor}!important;
						}
					`);

					this.AddStyle(`
						.theme--light.v-tabs-items {
							background-color: transparent !important;
						}
					`);
				}
        if(instance.theme.dark) {
            this.AddStyle(`.title-category{color: #fff;}`);
            this.AddStyle(`.v-application .black--text {color: #fff !important; caret-color: #fff !important;}`);
        }



    },
    AddStyle(styleString) {
        const style = document.createElement("style");
        document.head.append(style);
        style.textContent = styleString;
    },

}

export {
    vuetifyCustom
}
